import { Vue, Component } from "vue-property-decorator";

import RegisterNewUserStep1 from "./registerNewUserStep1/registerNewUserStep1";
import RegisterNewUserStep2 from "./registerNewUserStep2/registerNewUserStep2";
import RegisterNewUserStep2a from "./registerNewUserStep2a/registerNewUserStep2a";
import RegisterNewUserStep3 from "./registerNewUserStep3/registerNewUserStep3";
import RegisterNewUserStep4 from "./registerNewUserStep4/registerNewUserStep4";
import RegisterNewUserStep5 from "./registerNewUserStep5/registerNewUserStep5";

@Component({
  components: {
    RegisterNewUserStep1,
    RegisterNewUserStep2,
    RegisterNewUserStep2a,
    RegisterNewUserStep3,
    RegisterNewUserStep4,
    RegisterNewUserStep5,
  },
})
export default class RegisterNewUser extends Vue {}
